import axios from './axiosConfig'

export interface DriverData {
 name: string
 phone: string
 branch_id?: string
 vehicle_info?: string
 vehicle_plate?: string
 status?: 'available' | 'offline' | 'busy' | string
 compensation_type?: string
 fixed_salary_amount?: number | null
 fixed_salary_period?: 'daily' | 'weekly' | 'monthly' | null
 delivery_fee_percentage?: number | null
 fixed_amount_per_order?: number | null
 compensation_notes?: string | null
}

export interface DriverListParams {
 branch_id?: string
 search?: string
 status?: 'available' | 'offline' | 'busy' | string
 is_active?: boolean | string
 per_page?: number
 page?: number
 sort_by?: string
 sort_dir?: 'asc' | 'desc'
}

export interface DriverLite {
 id: string
 name: string
 phone?: string
 status?: string
 vehicle_info?: string | null
 active_deliveries_count?: number
}

export const driversAPI = {
 getAll: async (params?: DriverListParams | Record<string, unknown>) => {
 const response = await axios.get('/drivers', { params })
 return response.data
 },

 getActive: async (params?: { branch_id?: string }) => {
 const response = await axios.get('/drivers/all', { params })
 return response.data
 },

 getById: async (id: string) => {
 const response = await axios.get(`/drivers/${id}`)
 return response.data
 },

 create: async (data: DriverData) => {
 const response = await axios.post('/drivers', data)
 return response.data
 },

 update: async (id: string, data: DriverData) => {
 const response = await axios.put(`/drivers/${id}`, data)
 return response.data
 },

 toggleStatus: async (id: string) => {
 const response = await axios.post(`/drivers/${id}/toggle`)
 return response.data
 },

 delete: async (id: string) => {
 const response = await axios.delete(`/drivers/${id}`)
 return response.data
 },
}
